import { Page, PreviewServiceBlock } from "@/payload-types";
import Link from "next/link";
import RichText from "../../RichText";

type ContentFromSelectedPage = NonNullable<
  PreviewServiceBlock["selectedPages"]
>[number];

export default async function Card({
  service,
}: {
  service: ContentFromSelectedPage;
}) {
  const pageService = service.page as Page;

  const breadcrumb = pageService.breadcrumbs?.find(
    (f) => f.label == pageService.title,
  )?.url;

  return (
    <div className="relative w-[33%]">
      {service.page && (
        <Link
          href={breadcrumb ? breadcrumb : `/${(service.page as Page).slug}`}
        >
          <div className="absolute inset-px rounded-lg bg-gray-100 max-lg:rounded-t-[2rem] lg:rounded-tl-[2rem]" />
          <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-t-[calc(2rem+1px)] lg:rounded-tl-[calc(2rem+1px)]">
            <div className="p-10 pt-4">
              <p className="mt-2 text-lg/7 font-medium tracking-tight text-gray-950">
                {(service.page as Page).title}
              </p>
              {service.pageRichText && <RichText data={service.pageRichText} />}
              <p className="mt-5 flex justify-end text-sm/6 text-gray-600">
                En savoir plus →
              </p>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}
